var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuyingAStrap = function SvgBuyingAStrap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5412",
    transform: "translate(11728 3847)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#f1f1f1",
    "data-name": "Ellipse 737",
    transform: "translate(-11728 -3847)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4024"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3760"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0e2240",
    strokeWidth: 1.5,
    d: "M-11674.996-3815.952a16.7 16.7 0 0 1-3.767-2.9 16.8 16.8 0 0 1-2.9-3.767 9 9 0 0 1-.4-.855l-24.349 24.963a1.25 1.25 0 0 0-.335 1.167l1.115 4.931a1.25 1.25 0 0 0 .948.948l4.931 1.112a1.25 1.25 0 0 0 1.164-.339l24.308-24.922a10 10 0 0 1-.715-.338Zm-20.994 16.447a1.2 1.2 0 0 1-1.7.037 1.2 1.2 0 0 1-.037-1.7 1.2 1.2 0 0 1 1.7-.037 1.2 1.2 0 0 1 .037 1.7Zm2.841-2.968a1.2 1.2 0 0 1-1.7.037 1.2 1.2 0 0 1-.037-1.7 1.2 1.2 0 0 1 1.7-.037 1.2 1.2 0 0 1 .037 1.701Zm2.841-2.967a1.2 1.2 0 0 1-1.7.037 1.2 1.2 0 0 1-.037-1.7 1.2 1.2 0 0 1 1.7-.037 1.2 1.2 0 0 1 .033 1.7Z",
    "data-name": "Path 4518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M-11702.198-3823.258a1.01 1.01 0 0 0-1.45-.007l-.015.015-5.485 5.485c-.465.465-.841 1.287-.316 2.763.115.234.223.524.383.818a15.4 15.4 0 0 0 2.644 3.413 15.4 15.4 0 0 0 3.417 2.648 5 5 0 0 0 .818.379 4.6 4.6 0 0 0 .807.227 2.2 2.2 0 0 0 1.937-.465l5.559-5.529a1.037 1.037 0 0 0-.03-1.473Zm1.145 13.037a10 10 0 0 1-3.44-2.458 10 10 0 0 1-2.462-3.432l4.027-4.027 1.956 1.956-2.216 2.22a1.36 1.36 0 0 0 0 1.926 1.36 1.36 0 0 0 1.926 0l2.216-2.216 2.015 2.015Zm0 0",
    "data-name": "Path 4519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0e2240",
    strokeWidth: 1.5,
    d: "M-11684.372-3826.162a16.7 16.7 0 0 1-3.767-2.9 16.8 16.8 0 0 1-2.9-3.767 9 9 0 0 1-.4-.855l-9.548 9.741c-.034.034 7.6 8.041 7.908 7.736l9.423-9.616a10 10 0 0 1-.716-.339Z",
    "data-name": "Path 4520"
  }))))));
};
export { SvgBuyingAStrap as ReactComponent };
export default "/_next/static/images/buyingAStrap.svg";